<template>
  <p class="text-danger mt-1 mb-0">{{ message }}</p>
</template>

<script>
export default {
  name: 'EmptyStateInput',
  props: {
    message: {
      type: String,
      default: 'Data tidak tersedia. Silahkan hubungi IG'
    }
  }
}
</script>